import moment from "moment-timezone";

export const utcDateToLocaleString = (date: Date, tz: string = 'Europe/Brussels', format: string = 'DD/MM/YY HH:mm') =>
    moment.utc(date).tz(tz).format(format);